import findById from 'helpers/findById'
import replaceCamera from 'helpers/cameras/replaceCamera'

export default function addLensIds(state, action) {
  const { id, lensIds, fixedLensIds } = action
  const camera = findById({ id: id, state: state.cameras })

  const updatedCamera = Object.assign({}, camera, {
    isMultiImager: true,
    lensIds
  }, fixedLensIds && { fixedLensIds })

  return replaceCamera({ id: camera.id, updatedCamera, state })
}



// WEBPACK FOOTER //
// ./src/reducers/addLensIds.js